import { render, staticRenderFns } from "./BaseSideBar.vue?vue&type=template&id=892395b4&"
import script from "./BaseSideBar.vue?vue&type=script&lang=js&"
export * from "./BaseSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports